var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 1280 l0 -1160 580 0 580 0 0 60 0 60 -520 0 -520 0 0 1040 0 1040 1040 0 1040 0 0 -520 0 -520 60 0 60 0 0 580 0 580 -1160 0 -1160 0 0 -1160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 955 l0 -75 75 0 75 0 0 -255 0 -255 105 0 105 0 0 255 0 255 80 0 80 0 0 75 0 75 -260 0 -260 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 700 l0 -330 105 0 105 0 0 143 c0 78 4 148 8 155 6 8 31 -41 74 -140 l65 -153 121 -3 c67 -1 122 0 122 2 0 3 -40 79 -90 169 -49 90 -90 168 -90 173 0 5 41 77 90 159 l90 150 -117 3 c-64 1 -120 -1 -125 -6 -5 -5 -40 -69 -78 -143 l-69 -134 -1 143 0 142 -105 0 -105 0 0 -330z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b47a8aaa.svg";
export { ForwardRef as ReactComponent };